export const validateCanonical = (url) => {
  // Use Vite's import.meta.env instead of Node's process.env
  if (typeof import.meta !== 'undefined' && import.meta.env && !import.meta.env.DEV) {
    return;
  }

  if (!url) {
    console.warn('SEO Warning: Missing canonical URL.');
    return;
  }

  const expectedDomain = 'https://tudoconversor.com.br';

  if (!url.startsWith(expectedDomain)) {
    console.warn(`SEO Warning: Canonical URL should point to ${expectedDomain}. Found: ${url}`);
  }

  if (url.includes('?')) {
    console.warn(`SEO Warning: Canonical URL should not contain query parameters. Found: ${url}`);
  }

  // Check for duplicates in the DOM
  if (typeof document !== 'undefined') {
    const canonicalTags = document.querySelectorAll('link[rel="canonical"]');
    if (canonicalTags.length > 1) {
      console.warn(`SEO Warning: Multiple canonical tags found (${canonicalTags.length}). This can confuse search engines.`);
    }
  }

  // Validate against current window location
  if (typeof window !== 'undefined') {
    try {
      const currentUrlObj = new URL(window.location.href);
      const canonicalUrlObj = new URL(url);
      
      if (currentUrlObj.pathname !== canonicalUrlObj.pathname) {
         console.warn(`SEO Warning: Canonical pathname (${canonicalUrlObj.pathname}) does not match current pathname (${currentUrlObj.pathname}).`);
      }
    } catch (e) {
      // Ignore invalid URL parsing errors during dev checks
    }
  }
};